/**
 * Base interface for list elements - minimal constraint
 */
export interface ListElement {
  id: number;
  primary: string;
  secondary?: string;
  tertiary?: string;
  imageId?: number;
  archived?: boolean;
}

export const ListSelectionMode = {
  VIEW: 'VIEW',
  SINGLE_SELECTION: 'SINGLE_SELECTION',
  MULTIPLE_SELECTION: 'MULTIPLE_SELECTION',
} as const;

export type ListSelectionMode = typeof ListSelectionMode[keyof typeof ListSelectionMode];

export const isView = (mode: ListSelectionMode): boolean =>
  mode === ListSelectionMode.VIEW;

export const isSingleSelection = (mode: ListSelectionMode): boolean =>
  mode === ListSelectionMode.SINGLE_SELECTION;

export const isMultipleSelection = (mode: ListSelectionMode): boolean =>
  mode === ListSelectionMode.MULTIPLE_SELECTION;

export const isSelectionMode = (mode: ListSelectionMode): boolean =>
  isSingleSelection(mode) || isMultipleSelection(mode);
